import axios from "axios";

export const checkIfLedgerExists = async (orderNumber: string | undefined | null): Promise<boolean> => {
  if (!orderNumber) return false;
  const { data } = await axios.get(`/proxy/api/ledgers/ledgerexists?ordernumber=${orderNumber}`);
  return data.exists;
};

export const checkIfRecordingLedgerExists = async (orderNumber: string | undefined | null): Promise<boolean> => {
  if (!orderNumber) return false;
  return await checkIfLedgerExists(`${orderNumber}-RECORDING`);
};
